<template>
  <section class="users section">
    <div class="container">
      <h1 class="title">Users</h1>
      <div class="d-flex justify-content-end mb-4 mr-2 flex-wrap">
        <div
          class="d-flex align-items-center mr-auto text-dark col-12 col-md-auto mb-3 mb-md-0"
        >
          <span>
            <b v-if="!loading">
              <i class="fas fa-spin fa-circle-notch" v-if="busy"></i>
              {{ busy ? "" : users.length }}/{{ total }}</b
            >
            <i class="fas fa-spin fa-circle-notch" v-if="loading"></i>
            User{{ loading || total != 1 ? "s" : "" }}
          </span>
        </div>
        <select
          v-model="selectedType"
          :disabled="loading"
          @change="getFilteredUsers()"
          class="form-control row mb-0 mr-auto mr-md-4 mr-md-4 ml-0 col-5 col-md-auto w-auto"
        >
          <option
            v-for="_type in userTypes"
            :value="_type.value"
            :key="_type.value"
          >
            {{ _type.label }}
          </option>
        </select>
        <select
          v-model="selectedStatus"
          @change="getFilteredUsers()"
          :disabled="loading"
          class="form-control row mb-0 mr-0 ml-0 mr-md-4 col-5 col-md-auto w-auto"
        >
          <option
            v-for="status in statuses"
            :value="status.value"
            :key="status.value"
          >
            {{ status.label }}
          </option>
        </select>
        <button
          @click="addUser()"
          class="btn btn-sm btn-success mt-3 mt-md-0 col-5 col-md-auto"
        >
          <i class="fas fa-plus"></i> Add User
        </button>
      </div>
      <div class="position-relative mb-3" v-if="!loading">
        <input
          type="search"
          class="form-control"
          @keydown.enter="SearchUserText"
          v-model.trim="searchContent"
          placeholder="Search by Email Address, First or Last Name"
        />
        <span>
          <i
            class="fa fa-search search-icon text-primary"
            @click="SearchUserText"
          ></i>
          <i
            v-if="searchContent"
            class="fas fa-times cancel-icon"
            @click="(searchContent = ''), SearchUserText()"
          ></i>
        </span>
      </div>
      <loading v-if="loading" class="white-bg shadow-card" />
      <error-alert v-if="error.active" />
      <div
        class="overflow-auto desktop-shadow-card rounded"
        v-if="displayedUsers.length > 0 && !loading"
      >
        <table
          class="table table-striped mb-0 rounded responsive-mobile-tablet-table"
        >
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Email</th>
              <th class="text-center">Account Type</th>
              <th class="text-center">Created</th>
              <th class="text-center">Active</th>
              <th class="text-left">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="user in displayedUsers"
              :key="user.id"
              class="mobile-tablet-shadow-card rounded"
            >
              <td><b class="mobile-tablet-only mr-2">ID:</b>{{ user.id }}</td>
              <td>
                <b class="mobile-tablet-only mr-2">Name:</b>
                {{ user.last }}, {{ user.first }}
              </td>
              <td>
                <b class="mobile-tablet-only mr-2">Email:</b>{{ user.email }}
              </td>
              <td class="text-center">
                <b class="mobile-tablet-only mr-2">Account Type:</b
                ><badge>{{ user.role }}</badge>
              </td>
              <td class="text-center">
                <b class="mobile-tablet-only mr-2">Created:</b>
                {{ user.created_at ? prettyDateHelper(user.created_at) : "-" }}
              </td>
              <td class="text-center">
                <b class="mobile-tablet-only mr-2 mt-2">Active:</b
                ><i
                  class="fas fa-fw"
                  v-if="false"
                  :class="
                    user.active
                      ? `fa-check text-success`
                      : `fa-times text-danger`
                  "
                ></i>
                <button
                  title="Deactivate/Activate"
                  @click="updateUserStatus(user)"
                  :disabled="user.activating"
                  class="btn btn-sm"
                  :class="user.active ? 'btn-success' : 'btn-warning'"
                >
                  <span v-if="!user.activating">
                    <i
                      class="fas"
                      :class="user.active ? 'fa-user-alt' : 'fa-user-alt-slash'"
                      title="Deactivate/activate"
                    ></i>
                    <span class="mobile-tablet-only pl-2">{{
                      user.active ? "Deactivate" : "Activate"
                    }}</span>
                  </span>
                  <span
                    class="spinner-border spinner-border-sm"
                    v-if="user.activating"
                    role="status"
                    aria-hidden="true"
                  ></span>
                </button>
              </td>
              <td class="text-left td-actions">
                <button
                  v-if="!user.email_verified_at"
                  title="Make Email Verified"
                  @click="verifyEmail(user)"
                  class="btn btn-success btn-sm mr-1"
                >
                  <i
                    class="fas fa-spin fa-circle-notch"
                    v-if="emailVerifiedLoading"
                  ></i>
                  <span v-else>
                    <i class="fas fa-envelope"></i>
                    <span class="mobile-tablet-only pl-2"
                      >Make email verified</span
                    ></span
                  >
                </button>
                <router-link
                  :to="`/admin/users/${user.id}/edit`"
                  class="btn btn-secondary btn-sm mr-1"
                  ><i class="fas fa-edit" title="edit"></i
                  ><span class="mobile-tablet-only pl-2"
                    >Edit</span
                  ></router-link
                >

                <button
                  title="Delete"
                  @click="doRemoveUser(user.id)"
                  class="btn btn-danger btn-sm"
                >
                  <i class="fas fa-trash" title="delete"></i
                  ><span class="mobile-tablet-only pl-2">Delete</span>
                </button>
                <button
                  v-if="user.hasSpamReport"
                  title="Reported User"
                  :disabled="reportsLoading"
                  @click="displayUserReport(user)"
                  class="btn btn-link btn-sm"
                >
                  <i
                    class="fas fa-lg text-danger"
                    :class="
                      user.reportsLoading ? 'fa-spin fa-circle-notch' : 'fa-bug'
                    "
                    title="Reported User"
                  ></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <mugen-scroll :handler="loadMore" :should-handle="!busy && !loading">
          <alert
            v-if="busy"
            class="text-center p-2 mb-0 mobile-tablet-loadmore mobile-tablet-shadow-card"
            ><i class="fas fa-spin fa-circle-notch mr-2"></i>Loading more
            users...</alert
          >
        </mugen-scroll>
      </div>
      <alert
        v-if="!displayedUsers.length && !loading"
        class="white-bg shadow-card"
        >No users found</alert
      >
      <modal id="user-reports-modal">
        <div
          class="col-12 card shadow p-3"
          v-for="userReport of selectedUserReports"
          :key="userReport.id"
        >
          <h5 class="text-center mb-3 mt-2 font-weight-normal">
            Reported by
            <span class="text-dark font-weight-bolder"
              >{{ userReport.vendor_first }} {{ userReport.vendor_last }}</span
            >
            on
            <small class="text-secondary">{{
              userReport.created_at | fullDate
            }}</small>
          </h5>
          <div class="border p-3 rounded">{{ userReport.reason }}</div>

          <div
            class="border-top mt-3 text-center pt-3 pb-2"
            v-if="!userReport.handled && !userReport.handling"
          >
            <button
              @click="changeReportStatus(userReport, 1)"
              class="btn btn-success btn-sm"
            >
              Approve <i class="fas fa-thumbs-up"></i>
            </button>
            <button
              @click="changeReportStatus(userReport, 2)"
              class="btn btn-danger btn-sm ml-4"
            >
              Reject <i class="fas fa-thumbs-down"></i>
            </button>
          </div>
          <div
            class="border-top mt-3 text-center pt-3 pb-2"
            v-if="userReport.handled || userReport.handling"
          >
            <h4 v-if="!userReport.handling" class="text-primary">
              {{ userReport.handled == 1 ? "Approved" : "Rejected" }}
            </h4>
            <span
              class="spinner-border spinner-border-sm"
              v-if="userReport.handling"
              role="status"
              aria-hidden="true"
            ></span>
          </div>
        </div>
        <alert v-if="!selectedUserReports.length">No pending reports</alert>
      </modal>
    </div>
  </section>
</template>
<script>
import { mapState, mapActions } from "vuex";
import Swal from "sweetalert2";
import MugenScroll from "vue-mugen-scroll";
import { prettyDate } from "@/utils/helpers";
import dayjs from "dayjs";

export default {
  name: "users",
  components: {
    MugenScroll,
  },
  data() {
    return {
      selectedUserReports: [],
      selectedUser: undefined,
      reportsLoading: false,
      searchContent: "",
      latestSearch: "",
      limit: 50,
      busy: false,
      statuses: [
        { value: "", label: "Status" },
        { value: "1", label: "Active" },
        { value: "0", label: "Inactive" },
        { value: "REPORTED", label: "Reported" },
      ],
      userTypes: [
        { value: "", label: "Type" },
        { value: "ADMIN", label: "Admin" },
        { value: "CLIENT", label: "Client" },
        { value: "VENDOR", label: "Vendor" },
      ],
      selectedStatus: "",
      selectedType: "",
    };
  },
  computed: {
    ...mapState(["error"]),
    ...mapState({
      users: (state) => state.users.pagination.data,
      current: (state) => state.users.pagination.current,
      total: (state) => state.users.pagination.total || 0,
      emailVerifiedLoading: (state) => state.users.emailVerifiedLoading,
    }),
    loading: function () {
      return this.$store.state.loading;
    },
    displayedUsers: function () {
      if (this.users && this.users.length) {
        let dataToDisplay = this.users;
        if (this.selectedStatus == "1") {
          dataToDisplay = this.users.filter((user) => user.active);
        } else if (this.selectedStatus == "0") {
          dataToDisplay = this.users.filter((user) => !user.active);
        } else if (this.selectedStatus == "REPORTED") {
          dataToDisplay = this.users.filter((user) => user.hasSpamReport);
        }

        if (this.selectedType == "ADMIN") {
          dataToDisplay = dataToDisplay.filter((user) => user.isAdmin);
        } else if (this.selectedType == "CLIENT") {
          dataToDisplay = dataToDisplay.filter((user) => user.isClient);
        } else if (this.selectedType == "VENDOR") {
          dataToDisplay = dataToDisplay.filter((user) => user.isVendor);
        }

        return dataToDisplay;
      }
      return [];
    },
  },
  mounted() {
    this.getFilteredUsers();
  },
  methods: {
    ...mapActions({
      getUsers: "users/all",
      makeEmailVerified: "users/makeEmailVerified",
    }),
    doRemoveUser(id) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success ml-4",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, delete",
          cancelButtonText: "No, cancel!",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.value) {
            this.$store.dispatch("users/delete", id);
          }
        });
    },
    updateUserStatus(user) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success ml-4",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: `You are going to ${user.active ? "de" : ""}activate this user`,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: `Yes, ${user.active ? "de" : ""}activate`,
          cancelButtonText: "No, cancel!",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.value) {
            user.activating = true;
            this.$forceUpdate();
            this.$store
              .dispatch("users/update", {
                id: user.id,
                noRedirect: true,
                data: {
                  ...user,
                  active: !user.active,
                },
              })
              .then((success) => {
                user.activating = false;
                if (success) {
                  user.active = !user.active;
                }
                this.$forceUpdate();
              });
          }
        });
    },
    addUser() {
      this.$router.push(`/admin/users/add`);
    },
    displayUserReport(user) {
      this.selectedUser = user;
      this.selectedUserReports = [];
      user.reportsLoading = true;
      this.reportsLoading = true;
      return this.$store
        .dispatch("users/getUserReports", user.id)
        .then((res) => {
          this.selectedUserReports = res;
          user.reportsLoading = false;
          this.reportsLoading = false;
          this.$store.dispatch("showModal", "user-reports-modal");
        });
    },
    changeReportStatus(report, status) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success ml-4",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: `You are going to ${
            status == 1 ? "approve" : "reject"
          } this report`,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: `Yes, ${status == 1 ? "approve" : "reject"}`,
          cancelButtonText: "No, cancel!",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.value) {
            report.handling = true;
            this.$forceUpdate();
            this.$store
              .dispatch("users/changeReportStatus", { id: report.id, status })
              .then((success) => {
                report.handling = false;
                if (success) {
                  report.handled = status;
                  this.selectedUser.active = status == 2;
                }
                this.$forceUpdate();
              });
          }
        });
    },
    getFilteredUsers(page) {
      const payload = {
        limit: this.limit,
      };
      if (this.selectedStatus) {
        payload.status = this.selectedStatus;
      }
      if (this.selectedType) {
        payload.type = this.selectedType;
      }
      if (page) {
        payload.page = page;
      }
      if (this.searchContent) {
        payload.username = this.searchContent;
      }
      this.getUsers(payload).then(() => {
        this.busy = false;
      });
    },
    loadMore() {
      if (this.users.length < this.total) {
        this.busy = true;
        this.getFilteredUsers(this.current + 1);
      }
    },
    SearchUserText: function () {
      if (this.latestSearch == this.searchContent) {
        return;
      }
      this.latestSearch = this.searchContent;
      this.getFilteredUsers();
    },
    prettyDateHelper: function (date) {
      return prettyDate(date);
    },
    verifyEmail: function (user) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success ml-4",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: `You are going to verify this user account`,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: `Yes, verify`,
          cancelButtonText: "No, cancel!",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.value) {
            this.makeEmailVerified({ id: user.id }).then((res) => {
              if (res) {
                user.email_verified_at = dayjs();
              }
            });
          }
        });
    },
  },
};
</script>

<style scoped lang="scss">
.td-actions {
  width: 135px;
}
.cancel-icon,
.search-icon {
  z-index: 99;
  position: absolute;
  right: 40px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  color: #dc143c;
  cursor: pointer;
}
.search-icon {
  right: 15px;
}
</style>

<style lang="scss">
#user-reports-modal {
  .modal-body {
    max-height: 70vh;
    overflow: auto;
  }
}
</style>
